var utils = require('../../utils')

export default {
  name: 'message-send-harassment',
  created () {
  },
  data () {
    return {
      messageHarassmentContent: null,
      clicked: false
    }
  },
  computed: {
  },
  methods: {
    goTop: function () {
      this.$router.push({ path: '/'})
    },
    messageSent: function () {
      this.clicked = true
      var self = this
      var data = {
        'user_id': window.localStorage.getItem('user_id'),
        'shop_id': window.localStorage.getItem('shop_id'),
        'harassment_content': self.messageHarassmentContent,
        'base_url': process.env.ASOVI_URL
      }
      var callback = function() {
        self.$router.push({ path: '/message_sent_harassment/'})
      }
      this.$store.dispatch('MESSAGE_SEND', {data: data, callback: callback})
    },
    notInput: function() {
      if (this.messageHarassmentContent) {
        return false
      } else {
        return true
      }
    },
    rmEmoji: function(text) {
      this.messageHarassmentContent = utils.removeEmoji(text)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-send-harassment.js